import dayjs from "dayjs";
import "dayjs/locale/th";
import { formatNumber } from "../../utils";
import { roundHalfUp } from "../../utils/money";

// The report prints money and counts as whole numbers (the prototype), % to 0 or 2 places.

export const EMPTY_FIGURE_TEXT = "–";

const WHOLE = 0;
const THAI_LOCALE = "th";
const THRESHOLD_FORMAT = new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 });

/** Whole baht with thousands separators; – when there is no figure. */
export const moneyText = (value: number | null): string =>
  value === null ? EMPTY_FIGURE_TEXT : formatNumber(roundHalfUp(value, WHOLE), { decimals: WHOLE });

/** Whether the printed whole-baht figure is below zero (critical colour). */
export const isNegativeMoney = (value: number | null): boolean =>
  value !== null && roundHalfUp(value, WHOLE) < 0;

export const percentText = (value: number | null, decimals: number): string =>
  value === null
    ? EMPTY_FIGURE_TEXT
    : `${formatNumber(roundHalfUp(value, decimals), { decimals })} %`;

/** Whether the printed percentage is below zero (critical colour). */
export const isNegativePercent = (value: number | null, decimals: number): boolean =>
  value !== null && roundHalfUp(value, decimals) < 0;

export const countText = (value: number): string =>
  formatNumber(roundHalfUp(value, WHOLE), { decimals: WHOLE });

/** A threshold as MASTER typed it: 3.5, 45, -10. */
export const thresholdText = (value: number): string => THRESHOLD_FORMAT.format(value);

/** `YYYY-MM` → ต.ค. 2026. */
export const monthLabelOf = (month: string): string =>
  dayjs(`${month}-01`).locale(THAI_LOCALE).format("MMM YYYY");
